export enum ErrorType {
    Unknown,
    Generic,
    Http
}
